import { defaultFill } from '../utils/constants';
var muiChevronDownGlyph = {
    paths: [
        {
            path: 'M1.70710678,0.794897973 C1.31658249,0.404373682 0.683417511,0.404373682 0.292893219,0.794897973 C-0.0976310729,1.18542227 -0.0976310729,1.81858724 0.292893219,2.20911154 L7.29289322,9.20911154 C7.68341751,9.59963583 8.31658249,9.59963583 8.70710678,9.20911154 L15.7071068,2.20911154 C16.0976311,1.81858724 16.0976311,1.18542227 15.7071068,0.794897973 C15.3165825,0.404373682 14.6834175,0.404373682 14.2928932,0.794897973 L8,7.08779119 L1.70710678,0.794897973 Z',
            fill: defaultFill,
        },
    ],
    title: 'Chevron Down',
    width: 16,
    height: 10,
};
var muiChevronDown = {
    base: muiChevronDownGlyph,
};
export { muiChevronDown };
//# sourceMappingURL=chevronDown.js.map